import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom, buttonStyle, center } from '../../../helpers/getEmailStyles';

class NewInquiry extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      receiverName: PropTypes.string.isRequired,
      userType: PropTypes.string.isRequired,
      senderName: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkout: PropTypes.string.isRequired,
      personCapacity: PropTypes.number.isRequired,
    }).isRequired
  };

  render() {
    const { content: { receiverName, type, senderName, message, threadId, logo, siteName } } = this.props;
    const { content: { checkIn, checkOut, personCapacity } } = this.props;
    let messageURL = url + '/message/' + threadId + '/guest';
    if (type === "host") {
      messageURL = url + '/message/' + threadId + '/host';
    }
    let checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '';
    let checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {receiverName},
          </div>
          <EmptySpace height={20} />
          <div>
            Vous avez reçu une nouvelle demande sur {siteName} pour votre annonce !
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}><span style={fontWeightBold}>Détails de la demande :</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Voyageur :</span> {senderName}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Arrivée :</span> {checkInDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Départ :</span> {checkOutDate}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Voyageurs :</span> {personCapacity}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Message :</span></div>
          <div>
            {
              message && (message.trim()).split("\n").map(function (item, index) {
                return (
                  <span>{item}<br /></span>
                )
              })
            }
          </div>
          <EmptySpace height={20} />
          <div>
            Cliquez sur le bouton ci-dessous pour répondre :
          </div>
          <EmptySpace height={20} />
          <div style={center}>
            <a href={messageURL} style={buttonStyle}>Pré-approuver</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default NewInquiry;